import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";
import { delay } from "./Utils";

const UpdateSubmissionStatus = () => {
  const form = document.getElementById("UpdateSubmissionStatusForm");
  if (form) {
    form.addEventListener("submit", (ev) => {
      ev.preventDefault();
      const data = new FormData(form);
      data.append("action", "update_submission_status");
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
           console.log("Data received from server:", result);
          }
          delay(1000).then(() => {
            createToast({ type: "success", message: result.message, duration: 1000 });
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          createToast({ type: "error", message: "System Error!", duration: 1000 });
        });
    });
  }
};

export { UpdateSubmissionStatus };
